import React from 'react';
import ComingSoonPage from './componenets/ComingSoonPage';

export const BurialEtiquette = () => {
  return <ComingSoonPage title="Burial etiquette" description="Guidance on respectful cemetery visitation and burial etiquette." />;
}
